// ABOUTME: Business-wide background-jobs store (#1983). REST-backed (survives
// reload) — loaded on mount by AppShell, re-polled while jobs are active, and
// refreshed when a notification arrives on the SSE stream.

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { jobsApi, type JobItem } from '@/api/jobs'
import { createRequestSequencer } from './utils/requestSequencer'

interface JobsState {
  jobs: JobItem[]
  activeCount: number
  isLoading: boolean
  error: string | null
}

interface JobsActions {
  loadJobs: () => Promise<void>
}

type JobsStore = JobsState & JobsActions

const initialState: JobsState = {
  jobs: [],
  activeCount: 0,
  isLoading: false,
  error: null,
}

// Sequences overlapping loads so a stale resolution can't overwrite newer rows.
const jobsFetchSeq = createRequestSequencer()

export const useJobsStore = create<JobsStore>()(
  devtools(
    (set) => ({
      ...initialState,

      loadJobs: async () => {
        const token = jobsFetchSeq.begin()
        set({ isLoading: true, error: null })
        try {
          const { jobs, activeCount } = await jobsApi.getJobs()
          if (!jobsFetchSeq.isCurrent(token)) return
          set({ jobs, activeCount, isLoading: false })
        } catch {
          if (!jobsFetchSeq.isCurrent(token)) return
          set({ error: 'Failed to load jobs', isLoading: false })
        }
      },
    }),
    { name: 'jobs-store' }
  )
)
